import { getFnolTtlCardFeature } from '@dispatch/shared/services';
import { useQuery as useReactQuery } from 'react-query';

const FIVE_MINUTES = 5 * 60 * 1000;

const FEATURE_FETCHERS: Record<string, (tenantId: string) => Promise<boolean>> =
  {
    'fnol-ttl-card': getFnolTtlCardFeature,
  };

/**
 * useFeatureToggle - reads a tenant feature toggle from the configuration
 * service. The toggle value is a string parsed as a boolean; absent or
 * unparseable values resolve to false, matching the backend FeatureToggle.
 */
export const useFeatureToggle = (featureId: string, tenantId?: string) => {
  const { data, isLoading } = useReactQuery<boolean>(
    ['feature-toggle', featureId, tenantId],
    () => {
      const fetcher = FEATURE_FETCHERS[featureId];
      if (!fetcher || !tenantId) {
        return Promise.resolve(false);
      }
      return fetcher(tenantId);
    },
    {
      enabled: !!tenantId && !!FEATURE_FETCHERS[featureId],
      staleTime: FIVE_MINUTES,
    }
  );

  return {
    isEnabled: data ?? false,
    isLoading,
  };
};
